import React from 'react'
import styled from 'styled-components';
import ActionsContextV2 from '../ActionsContextV2';

const Container = styled.div`
width:150px;
height:30px;
display:flex;
align-items:center;
justify-content:center;
border-radius:15px;

`

const ApprovalTypeContainer = styled.div`

`

const ActionApprovalTypePillV2 = ({action}) => {
    const {approvalType,approvalTypeColor} = action;
    const context = React.useContext(ActionsContextV2);
    const uniqueProcedureName = action.procedureSdn + action.rev;
    let approvalTypeColorBasedOnHover = uniqueProcedureName === context.procedureSdnWithRev ? 'white' : approvalTypeColor;

    return(
        <Container 
            style={{backgroundColor:approvalTypeColorBasedOnHover,
                borderStyle: uniqueProcedureName === context.procedureSdnWithRev ? 'solid' : 'none',
                borderWidth: uniqueProcedureName === context.procedureSdnWithRev ? '.3px' : '0px',
                boxShadow: uniqueProcedureName === context.procedureSdnWithRev ? '0px 2px 0px 0px ' + approvalTypeColor: 'none',
                borderColor: uniqueProcedureName === context.procedureSdnWithRev ? approvalTypeColor : 'none',
                fontWeight: uniqueProcedureName === context.procedureSdnWithRev ? '500' : '400',
                cursor: 'context-menu',
            }}
            onMouseEnter={()=>context.setHoverAction(action)}
            onMouseLeave={()=>context.setHoverAction(null)}
        >
            <ApprovalTypeContainer>
                {approvalType}
            </ApprovalTypeContainer>
        </Container>
    );
}

export default ActionApprovalTypePillV2;